import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { isDetractorScore, isPromoterScore } from 'modules/enps/lib/getRespondentsTypeCount'

interface Props {
  answers: Record<string, string | number>
  questionIds: Set<string>
}

const Row = ({ answers, questionIds }: Props) => {
  const sortedAnswerValues = Array.from(questionIds)
    .map((questionId) => answers[questionId as string])
    .reverse()

  const NOT_ANSWERED = '-'

  const userType = (score: number) => {
    return isPromoterScore(score)
      ? i18n.t('enps.results.user.promoter')
      : isDetractorScore(score)
        ? i18n.t('enps.results.user.detractor')
        : i18n.t('enps.results.user.passive')
  }

  return (
    <Table.Row>
      {sortedAnswerValues.map((value, key) => (
        <Table.Cell key={key}>
          <Text.Normal htmlTag="p" whiteSpace="breakSpaces">
            {value || NOT_ANSWERED}
          </Text.Normal>
        </Table.Cell>
      ))}
      <Table.Cell key={3}>
        <Text.Normal htmlTag="p" whiteSpace="breakSpaces">
          {userType(sortedAnswerValues[1] as number)}
        </Text.Normal>
      </Table.Cell>
    </Table.Row>
  )
}

export default observer(Row)
